import MaintenanceWorkflowForwardingCheckinEntrySection from '@/features/maintenanceWorkflow/pages/Show/components/tabs/ForwardingsTabs/Sections/CheckinEntry'
import MaintenanceWorkflowForwardingDirectiveEntrySectionExecutionEntry from '@/features/maintenanceWorkflow/pages/Show/components/tabs/ForwardingsTabs/Sections/DirectiveEntry/Entries/ExecutionEntry'
import MaintenanceWorkflowForwardingEstablishmentChoiceEntrySection from '@/features/maintenanceWorkflow/pages/Show/components/tabs/ForwardingsTabs/Sections/EstablishmentChoiceEntry'
import MaintenanceWorkflowForwardingFinancialReviewEntrySection from '@/features/maintenanceWorkflow/pages/Show/components/tabs/ForwardingsTabs/Sections/FinancialReviewEntry'

const ExecutionEntryOnGoingCheckin = () => {
  return (
    <>
      <MaintenanceWorkflowForwardingDirectiveEntrySectionExecutionEntry />

      <MaintenanceWorkflowForwardingCheckinEntrySection showTransportAutoEntriesDeliveryCode />

      <MaintenanceWorkflowForwardingFinancialReviewEntrySection />

      <MaintenanceWorkflowForwardingEstablishmentChoiceEntrySection showProposalDiagnostic />
    </>
  )
}

export default ExecutionEntryOnGoingCheckin
